
import { defineComponent, PropType } from 'vue'
import router from '@/router'
import { store } from '@/store'


export default defineComponent({
  components: { },
  name: 'PayWall',
  props: {
    feature: String as PropType<'LIVE_MODE'>
  },
  setup(props) {

    function proceed() {
      store.modal.hideModal('PayWall')
      router.push('/account')
    }
    
    return { proceed }
  }
})
